import { useLayoutEffect, useRef, useState } from 'react';

import useConfirmBase from '../useConfirmBase';

import ConfirmPopover from './ConfirmPopover';

function useConfirmPopover<TElement extends HTMLElement>(loading?: boolean) {
  const anchor = useRef<null | TElement>(null);
  const [anchorEl, setAnchorEl] = useState<null | TElement>(null);
  const { request, actions, prompt, open, onCancel } = useConfirmBase(loading);

  useLayoutEffect(() => {
    setAnchorEl(anchor.current);
  }, [anchor]);

  return {
    anchor,
    open,
    popover: (
      <ConfirmPopover anchor={anchorEl} onCancel={onCancel} open={open} prompt={prompt}>
        {actions}
      </ConfirmPopover>
    ),
    request,
  };
}

export default useConfirmPopover;
